'use client';

/**
 * @brisa/ui · components/ui/tooltip — shadcn Tooltip (Facelift v1)
 *
 * Feature: migracao-facelift-v1
 * Companion do PinMap em /clubes — abre ao clicar (não no hover) num pin,
 * mostrando o nome do club. Reusável em outros contextos (badges, ícones).
 *
 * Pattern shadcn canônico — `@radix-ui/react-tooltip` com Provider + Root +
 * Trigger + Content. `delayDuration={0}` por padrão pra Tooltip click-driven
 * (consumer pode override).
 *
 * 'use client' obrigatório — Radix Tooltip usa portals e estado interno.
 */
import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../../lib/utils';

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'z-50 overflow-hidden rounded-md px-3 py-1.5',
      'bg-[hsl(var(--text-100))] text-[hsl(var(--neutral-white))]',
      'font-body text-xs font-medium leading-tight',
      'shadow-md',
      'animate-in fade-in-0 zoom-in-95',
      'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
      'data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1',
      'data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1',
      className,
    )}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
